import { render, staticRenderFns } from "./OnboardCropper.vue?vue&type=template&id=4d59a3a0&"
import script from "./OnboardCropper.vue?vue&type=script&lang=js&"
export * from "./OnboardCropper.vue?vue&type=script&lang=js&"
import style0 from "./OnboardCropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports